<script lang="typescript">
    export let image: string;
    export let isActive: boolean;

    let overlay: HTMLDivElement;
    let imageElement: HTMLImageElement;

    $: if (overlay && imageElement && isActive) {
        overlay.classList.remove("opacity-10");
        overlay.classList.add("opacity-0");
    } else if (overlay && imageElement) {
        overlay.classList.add("opacity-10");
        overlay.classList.remove("opacity-0");
    }

    let isSVG: boolean = image.endsWith(".svg");
</script>

<div class="w-16 h-16 my-0 rounded-full overflow-hidden relative flex-shrink-0">
    <img
        bind:this={imageElement}
        src={image}
        class="benefit transition-all duration-700 object-cover h-full w-full {isSVG
            ? 'bg-primary-light'
            : ''}"
        alt="lens benefit"
    />
    <div class="hide-on-hover img-overlay opacity-10" bind:this={overlay} />
</div>
